var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{style:({width: this.size/2 + 'px'}),attrs:{"src":_vm.handleSrc,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }